<template>
    <div class="page">
        <div class="title">{{InfoForm.title}}</div>
        <div style="margin-bottom: 20px;color: #cccccc;font-size: 14px">创建时间:{{InfoForm.create_time|dataFormat}}, 更新时间:{{InfoForm.update_time|dataFormat}}</div>
        <p v-html="InfoForm.content"></p>
    </div>
</template>
<script>
import {notice_info} from "@/api/user";
import {mapGetters} from "vuex";

export default {
  computed:{
    ...mapGetters(['app_id'])
  },
  data(){
    return{
      InfoForm:{}
    }
  },
   methods:{
    async get_info(){
      const res = await notice_info({app_id:this.app_id,id:this.$route.query.id})
      if(res.code == 200){
        console.log(res)
        this.InfoForm = res.data
      }
    }
   },
  mounted() {
    this.get_info()
  }
}
</script>
<style scoped lang="scss">
.page{
  width: 100%;
  height: 100%;
  padding: 2em 30em;
  overflow: auto;
  box-sizing: border-box;
  .title{
    width: 100%;
    text-align: center;
    font-size: 2em;
    font-weight: bold;
    margin-bottom: 20px;
  }
}
</style>